import React from 'react';
import Paper from 'material-ui/Paper';
import moment from 'moment';
import List from 'material-ui/List';

const ItemContainer = ({ children, data }) => {
    // const payload = data.payload || {};

    return (
        <div className="tl-item">
            <div className="tl-item-datetime">
                <div><i className="material-icons">access_time</i></div>
                <div>{moment(data.date).format('DD/MM/YYYY HH:mm')}</div>
            </div>

            <List>
                <Paper className="tl-item-paper">
                    {children}
                </Paper>
            </List>
        </div>
    )

}

export default ItemContainer;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/ItemContainer.js